import "react-datepicker/dist/react-datepicker.css";

import UIDatePicker, { DatePickerBaseProps } from "./index";

import React from "react";

export interface UIDatePicker2Props extends DatePickerBaseProps {
  value1?: Date;
  value1Changed?: (value: Date) => void;
  value2?: Date;
  value2Changed?: (value: Date) => void;
  className?: string;
  etcText?: boolean;
}

export default UIDatePicker2;
function UIDatePicker2(props: UIDatePicker2Props) {
  return (
    <div>
      <UIDatePicker
        {...props}
        value={props.value1}
        valueChanged={(value) => {
          if (props.value1Changed != null) {
            props.value1Changed(value);
          }
        }}
        withoutWrapper={true}
        maxDate={props.value2}
      />
      <span>&nbsp;~&nbsp;</span>
      <UIDatePicker
        {...props}
        value={props.value2}
        valueChanged={(value) => {
          if (props.value2Changed != null) {
            props.value2Changed(value);
          }
        }}
        withoutWrapper={true}
        minDate={props.value1}
      />
      {props.etcText === true && <small className="small">00개월00일</small>}
    </div>
  );
}
